import { useCallback, useRef, useState } from 'react';

import { decodeTicket, isTicketExpired } from '@features/video/lib/ticket';

// Билет кешируем до истечения: один запрос на все обращения, параллельные ждут его же
export function useCachedTicket(request: () => Promise<string>): {
  ticket: string | null;
  ensureTicket: () => Promise<string>;
} {
  const [ticket, setTicket] = useState<string | null>(null);
  const refRequest = useRef<Promise<string> | null>(null);

  const ensureTicket = useCallback(async () => {
    const claims = ticket ? decodeTicket(ticket) : null;
    if (ticket && claims && !isTicketExpired(claims)) return ticket;
    refRequest.current ??= request()
      .then((next) => {
        setTicket(next);
        return next;
      })
      .finally(() => {
        refRequest.current = null;
      });
    return refRequest.current;
  }, [request, ticket]);

  return { ticket, ensureTicket };
}
